module.exports = __webpack_public_path__ + "img/Wizard.677dce19.png";